import { PatientMedication } from "../../../../../../../services";
import { createMapper } from "../../../../../../../utils/utils";
import * as Yup from "yup";

export const DOSAGE_LIST = [
  { value: "mg", label: "Mg" },
  { value: "tablet", label: "Tablet (s)" },
  { value: "g", label: "g" },
  { value: "mcg", label: "Mcg" },
  { value: "mL", label: "mL" },
  { value: "unit", label: "Unit" },
  { value: "IU", label: "IU" },
  { value: "mL per hour", label: "mL Per Hour" },
  { value: "mg per kg", label: "Mg Per Kg" },
  { value: "puffs", label: "Puffs" },
  { value: "drops", label: "Drops" },
  { value: "sprays", label: "Sprays" },
  { value: "capsule", label: "Capsule" },
  { value: "teaspoon", label: "Teaspoon" },
  { value: "tablespoon", label: "Tablespoon" },
  { value: "mEq", label: "mEq" },
  { value: "%", label: "%" },
  { value: "mg/mL", label: "Mg/mL" },
];

export const WHEN_LIST = [
  { value: "BEFORE_MEAL", label: "Before Meal" },
  { value: "WITH_MEAL", label: "With Meal" },
  { value: "AFTER_MEAL", label: "After Meal" },
  { value: "IN_THE_MORNING", label: "In The Morning" },
  { value: "AFTERNOON_MEAL", label: "Afternoon Meal" },
  { value: "BEDTIME", label: "Bedtime" },
  { value: "PRN", label: "PRN" },
];

export const FREQUENCY_LIST = [
  { value: "EVERY_TWO_HOURS", label: "Every Two Hours" },
  { value: "EVERY_FOUR_HOURS", label: "Every Four Hours" },
  { value: "EVERY_SIX_HOURS", label: "Every Six Hours" },
  { value: "EVERY_EIGHT_HOURS", label: "Every Eight Hours" },
  { value: "EVERY_TEN_HOURS", label: "Every Ten Hours" },
  { value: "EVERY_DAY", label: "Every Day" },
  { value: "TWICE_A_DAY", label: "Twice A Day" },
  { value: "THRICE_A_DAY", label: "Thrice A Day" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "EVERY_OTHER_DAY", label: "Every Other Day" },
  { value: "THREE_TIME_WEEKLY", label: "Three Time Weekly" },
  { value: "FOUR_TIME_WEEKLY", label: "Four Time Weekly" },
];

export const ROUTE_LIST = [
  { value: "Oral", label: "Oral" },
  { value: "Topical", label: "Topical" },
  { value: "Subcutaneous", label: "Subcutaneous" },
  { value: "Intramuscular", label: "Intramuscular" },
  { value: "Intravenous", label: "Intravenous" },
  { value: "Inhalation", label: "Inhalation" },
  { value: "Transdermal", label: "Transdermal" },
  { value: "Nasal", label: "Nasal" },
  { value: "Sublingual", label: "Sublingual" },
  { value: "Rectal", label: "Rectal" },
  { value: "Vaginal", label: "Vaginal" },
  { value: "Optic", label: "Optic" },
];

export const ROUTE_LIST_MAPPER = createMapper(ROUTE_LIST);
export const DOSAGE_LIST_MAPPER = createMapper(DOSAGE_LIST);
export const FREQUENCY_LIST_MAPPER = createMapper(FREQUENCY_LIST);

export type Medication = Omit<PatientMedication, "patient" | "prescribedBy"> & {
  prescribedBy?: { value: string; label: string };
  lifeTime: boolean;
};

export const MEDICINE_INITIAL_VALUE: any = {
  medicalCodes: undefined,
  prescribedBy: undefined,
  medicationStartDate: new Date().toISOString(),
  lifeTime: false,
};

export const MEDICINE_VALIDATION_SCHEMA = Yup.object().shape({
  medicalCodes: Yup.string().required().label("Medicine Name"),
  // prescribedBy: Yup.object().required().label("Prescribed By"),
  medicationStartDate: Yup.string().required().label("Start Date"),
});
